import React, { Fragment } from "react";
import { connect, FastField } from "formik";
import { compose } from "redux";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import { TextField, FormHelperText } from "@material-ui/core";

const styles = theme => ({
  labelRoot: {
    fontSize: "17px"
  },
  inputField: {
    borderBottom: "1px solid #2196F3"

  },
  inputFieldNoUnderline: {
    fontSize: "17px"
  },
  error: {
    "& input": {
      borderBottom: "1px solid red"
    }
  }
});
const TextAreaInput = ({ label, fieldName, formik, classes, disableUnderline, ...otherProps }) => (
  <FastField
    name={fieldName}
    render={({ field, form }) => {
      const { touched, errors } = form;
      const fieldError = _.get(errors, fieldName);
      const fieldTouched = _.get(touched, fieldName);

      return (
        <>
          <TextField
            type="text"
            name={fieldName}
            multiline
            InputProps={{
              classes: {
                input: disableUnderline ? classes.inputFieldNoUnderline : classes.inputField,
                error: classes.error
              },
              disableUnderline: true
            }}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            error={Boolean(fieldError) && fieldTouched}
            id={fieldName}
            label={label || ""}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            {...otherProps}
          />
          {Boolean(fieldError) && <FormHelperText>{fieldError}</FormHelperText>}
        </>
      );
    }}
  />
);

export default compose(
  withStyles(styles)
)(TextAreaInput);
